import {
    GET_USER,
    EDIT_USER,
    ADD_USER,
    ALL_USER
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    data: null
  }
  
  const userList = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_USER:
        case ADD_USER:
            state = {
              ...state,
              data:action.payload.data,
              loading: false,
            }
            break
        case GET_USER:
            state = {
                ...state,
                loading: true,
            }
            break
        case ALL_USER:
            state = {
                ...state,
                data:action.payload.data,
                loading: false
            }
            break
        default:
        break
    }
    return state
  }

  export default userList
  